export default __webpack_public_path__ + "static/media/background-portal-4.6f887a5a.svg";